export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SECS = 15;
export const RES_PER_PAGE = 10;
export const KEY = "d4226af1-cc75-4c80-b23c-3a4d2ed69242";
export const MODAL_CLOSE_SECS = 2.5;
